export const ActivityIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.334 6.6673C8.5975 7.4038 7.40339 7.4038 6.66689 6.6673C5.93039 5.9308 5.93038 4.73669 6.66689 4.00019C7.40339 3.26369 8.59749 3.26369 9.334 4.00019C10.0705 4.73669 10.0705 5.9308 9.334 6.6673Z"
      fill="#00082F"
      fillOpacity="0.275"
    />
    <path
      d="M9.33359 12.0013C8.59715 12.7377 7.40315 12.7377 6.66671 12.0013C5.93028 11.2648 5.93028 10.0708 6.66671 9.3344C7.40315 8.59797 8.59715 8.59797 9.33359 9.3344C10.07 10.0708 10.07 11.2648 9.33359 12.0013Z"
      fill="#00082F"
      fillOpacity="0.275"
    />
  </svg>
);
